/**
 * Reports editor actions that only happen in the browser to our own backend
 * (`POST /api/events`). Fire-and-forget: failures are ignored and never affect the UI.
 * Independent of any third-party analytics (e.g. Google Analytics can be added separately).
 */
import type { GraphType, RangeName } from '../src/graph/options';

export type ClientEvent =
    | 'graph_previewed'
    | 'graph_downloaded'
    | 'embed_code_copied'
    | 'graph_url_copied'
    | 'graph_type_selected';

export interface ClientEventProps {
    graphType?: GraphType;
    dateRange?: RangeName;
    format?: 'markdown' | 'html';
}

export const trackEvent = (event: ClientEvent, props: ClientEventProps = {}): void => {
    try {
        void fetch('/api/events', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ event, ...props }),
            keepalive: true, // still delivered if the page is closing (e.g. after a download)
            credentials: 'omit',
        }).catch(() => undefined);
    } catch {
        /* analytics must never break the editor */
    }
};
